<template>
    <div class="newsletter-sample">
        <div class="inner-wrapper">
            <div class="container">
                <div class="logo">
                    <svg viewbox="0 0 135 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <!-- eslint-disable-next-line max-len -->
                        <path d="M88.892 21H95.8c3.344 0 4.774-2.002 4.774-4.18s-1.21-3.234-2.53-3.696v-.066c.66-.33 1.848-1.364 1.848-3.234 0-2.002-1.144-3.784-4.334-3.784h-6.666V21Zm1.804-8.426V7.646h4.686c1.694 0 2.618.924 2.618 2.442 0 1.474-1.012 2.486-2.486 2.486h-4.818Zm0 6.798v-5.214h5.06c2.024 0 2.882 1.21 2.882 2.596 0 1.408-.792 2.618-2.992 2.618h-4.95ZM103.561 21h1.738V4.83h-1.738V21Zm10.239.22c3.454 0 5.962-2.552 5.962-6.028 0-3.476-2.508-6.028-5.962-6.028-3.432 0-5.94 2.552-5.94 6.028 0 3.476 2.508 6.028 5.94 6.028Zm.022-1.562c-2.42 0-4.136-1.804-4.136-4.466s1.716-4.466 4.114-4.466c2.398 0 4.136 1.804 4.136 4.466s-1.738 4.466-4.114 4.466Zm13.489 5.544c3.564 0 5.456-2.046 5.456-5.434V9.384h-1.562l-.088 1.518c-.902-1.166-2.288-1.738-3.96-1.738-3.058 0-5.632 2.288-5.632 5.852 0 3.498 2.222 5.808 5.544 5.808 1.848 0 3.19-.704 4.07-1.958l-.088.968c.044 2.376-1.122 3.938-3.586 3.938-2.178 0-3.124-.968-3.586-2.156h-1.848c.418 1.694 1.782 3.586 5.28 3.586Zm.066-5.918c-2.442 0-4.048-1.76-4.048-4.268 0-2.53 1.606-4.312 4.07-4.312 2.288 0 3.828 1.76 3.828 4.29 0 2.552-1.54 4.29-3.85 4.29ZM6.61 5h2.51l6.6 15.77h-2.421l-1.135-2.876H3.586L2.42 20.77H0L6.61 5Zm4.76 10.92-.743-1.813H5.093l-.724 1.814h7.001Zm-1.466-3.666-.422-1.022c-.673-1.673-1.256-3.066-1.627-4.108-.352 1.042-.934 2.435-1.607 4.108l-.422 1.022h4.078Zm6.007 2.384c0-3.777 2.792-6.352 6.398-6.352 3.093 0 5.444 1.764 5.976 4.8h-2.39c-.533-1.874-1.818-2.716-3.626-2.716-2.532 0-3.978 1.854-3.978 4.268 0 2.525 1.537 4.268 3.998 4.268 1.788 0 3.113-.902 3.626-2.525h2.39C27.562 19.347 25.192 21 22.188 21c-3.867 0-6.277-2.695-6.277-6.362Zm14.172-6.121h2.14l.09 1.553c.764-1.093 1.909-1.784 3.345-1.784h.21v2.575h-.35c-2.441 0-3.114 1.393-3.114 3.567v6.331h-2.32V8.517Zm6.168 6.121c0-3.757 2.812-6.352 6.438-6.352 3.767 0 6.439 2.735 6.439 6.352 0 3.667-2.722 6.352-6.439 6.352-3.716 0-6.438-2.685-6.438-6.352Zm10.506-.02c0-2.415-1.577-4.248-4.068-4.248-2.531 0-4.048 1.854-4.048 4.248 0 2.555 1.698 4.288 4.068 4.288 2.4 0 4.048-1.833 4.048-4.288Zm4.088-6.101h2.07l.16 1.272c.954-.992 2.25-1.503 3.927-1.503 2.903 0 4.53 1.713 4.53 4.75v7.723h-2.32v-7.283c0-1.994-.793-3.086-2.702-3.086-2.069 0-3.344 1.323-3.344 3.316v7.053h-2.32V8.517Zm13.229 0h2.3v12.242h-2.3V8.517Zm4.7 8.466h2.26c.232 1.482 1.417 2.133 3.165 2.133 1.446 0 2.53-.56 2.53-1.693 0-.791-.37-1.112-.953-1.322-.563-.21-1.135-.3-2.3-.491-1.206-.18-2.05-.37-2.773-.721-1.115-.531-1.557-1.533-1.557-2.645 0-2.595 2.05-3.968 4.671-3.968 2.863 0 4.761 1.323 4.902 3.988h-2.21c-.14-1.413-1.256-2.114-2.692-2.114-1.537 0-2.44.761-2.44 1.803 0 .671.32 1.022.933 1.252.603.23 1.718.351 2.672.491.904.14 1.748.3 2.511.722 1.025.55 1.507 1.623 1.507 2.715 0 1.162-.442 2.184-1.276 2.855-.884.721-2.049 1.002-3.535 1.002-2.994.01-5.183-1.102-5.414-4.007Z" fill="#00204D" />
                    </svg>
                </div>
                <div class="title">
                    {{ modal.title }}
                </div>
                <div class="articles-wrap">
                    <div class="title">
                        {{ modal.articlesTitle }}
                    </div>
                    <div class="grid">
                        <template v-for="article in computedArticles">
                            <dynamic-link
                                :key="article.id"
                                class="item"
                                :to="article.link"
                                native-type="a"
                                target="_blank"
                            >
                                <a-picture
                                    v-if="article.image_id || (fallback_images && fallback_images.length)"
                                    class="image"
                                    :link="article.image_id || fallback_images[0]"
                                    fit="cover"
                                    size="blogCover"
                                    :alt="article.title"
                                />
                                <v-clamp class="item-title" tag="div" :max-lines="2">
                                    {{ article.title }}
                                </v-clamp>
                                <v-clamp class="excerpt" tag="p" :max-lines="4">
                                    {{ article.description }}
                                </v-clamp>
                            </dynamic-link>
                        </template>
                    </div>
                </div>
                <hr class="separator" />
                <div class="insights">
                    <div class="title">
                        {{ modal.insights.title }}
                    </div>
                    <a-link
                        class="link"
                        :to="modal.insights.buttonLink"
                        target="_blank"
                        :text="modal.insights.buttonText"
                    />
                </div>
                <div class="footer">
                    <div class="grid">
                        <div class="item footer-logo">
                            <a-logo fill="dark" />
                        </div>
                        <div class="item notice">
                            <div class="address">
                                <a-dangerous-html tag="p" :content="modal.addressText" />
                            </div>
                            <div class="notice">
                                <a-dangerous-html tag="p" :content="modal.noticeText" />
                            </div>
                        </div>
                        <div class="item nav">
                            <ul>
                                <li v-for="(link, i) in modal.footerMenu" :key="i">
                                    <a :href="link.link" target="_blank" title="link.title">{{ link.title }}</a>
                                </li>
                            </ul>
                        </div>
                        <a-social class="item social" :social="modal.socialLinks" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VClamp from 'vue-clamp';
import ADangerousHtml from '@core/components/dangerous-html/dangerous-html.vue';
import DynamicLink from '@core/components/dynamic-link/dynamic-link.vue';
import ALink from '@core/components/link/link.vue';
import ALogo from '@core/components/logo/logo.vue';
import APicture from '@core/components/picture/picture.vue';
import ASocial from '@core/components/social/social.vue';
import newsletterSampleData from './newsletter-sample.js';

export default {
    components: {
        ALogo,
        APicture,
        DynamicLink,
        ADangerousHtml,
        ALink,
        ASocial,
        VClamp,
    },
    props: {
        articles: {
            type: Array,
            default: () => [],
        },
        // eslint-disable-next-line vue/prop-name-casing
        fallback_images: {
            type: Array,
            default: () => ['@ac5c488ea6706d9e8d958f770d983a7b'],
        },
    },
    computed: {
        modal() {
            return { ...newsletterSampleData };
        },
        computedArticles() {
            if (!this.articles.length) return this.modal.articles;
            return this.articles.slice(0, 4);
        },
    },
};
</script>

<style lang="postcss" scoped>
.newsletter-sample {
    padding: 0 28px;
    font-family: Arial, Helvetica, sans-serif;
    background: #e9f3ff;

    @media (--viewport-mobile-wide) {
        padding: 0 56px;
    }

    .inner-wrapper {
        background: var(--av-inversed-primary);
        padding: 24px 0;
    }

    .container {
        max-width: 736px;
        margin: 0 auto;
        padding: 0 24px;

        @media (--viewport-tablet) {
            padding: 0 48px;
        }
    }

    .logo {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;

        svg {
            max-width: 135px;
            max-height: 25px;
        }

        span {
            margin-inline-start: 8px;
            color: var(--av-nav-primary);
            font-size: 22px;
            line-height: 24px;
        }
    }

    .title {
        @mixin display;

        margin-top: 60px;
        color: var(--av-nav-primary);
        text-align: center;
        font-weight: 700;
    }

    .articles-wrap {
        @mixin title;

        color: var(--av-nav-primary);
        font-weight: 700;

        .title {
            @mixin title;

            color: var(--av-nav-primary);
            text-align: center;
            font-weight: 700;
            margin: 8px 0 40px 0;

            @media (--viewport-mobile-wide) {
                margin: 48px 0 40px 0;
            }
        }

        .grid {
            display: flex;
            flex-flow: row wrap;
            align-items: flex-start;
            justify-content: space-between;
        }

        .item {
            @mixin paragraph;

            flex-basis: 100%;
            margin-bottom: 40px;
            text-decoration: none;

            @media (--viewport-mobile-wide) {
                flex-basis: calc(50% - 16px);
            }

            .item-title {
                margin: 16px 0 8px 0;
                color: var(--av-brand-secondary);
                text-align: start;
            }

            .excerpt {
                text-align: start;
                font-weight: 400;
                color: var(--av-fixed-light);
            }
        }
    }

    .separator {
        margin: 16px auto 40px auto;
        border: 1px solid var(--av-brand-secondary-light);
    }

    .insights {
        text-align: center;
        .title {
            @mixin title;

            margin-bottom: 24px;
            color: var(--av-nav-primary);
            text-align: center;
            font-weight: 700;
        }

        .link {
            @mixin paragraph;

            display: inline-block;
            padding: 8px 40px;
            font-weight: 700;
            text-decoration: none;
            border-radius: 4px;
            color: var(--av-inversed-primary);
            background: var(--av-button-action);
            &:hover {
                background: var(--av-button-action-hover);
            }
            &:active {
                background: var(--av-button-action-active);
            }
        }
    }

    .footer {
        margin-top: 56px;
        padding-bottom: 20px;

        @media (--viewport-tablet) {
            padding: 34px 0 20px 0;
        }

        .grid {
            text-align: start;

            @media (--viewport-tablet) {
                display: grid;
                grid-template-columns: 50px 4fr 2fr;
                grid-column-gap: 20px;
            }

            .item {
                &.footer-logo {
                    svg {
                        width: 32px;
                        height: 32px;
                    }
                }

                &.notice {
                    @mixin caption;

                    .address {
                        margin-top: 16px;
                        color: var(--av-nav-primary);

                        @media (--viewport-tablet) {
                            margin-top: 0;
                        }
                    }

                    .notice {
                        margin: 16px 0;
                        color: rgba(146, 164, 187, 1);

                        @media (--viewport-tablet) {
                            margin-top: 8px;
                            margin-bottom: 0;
                        }
                    }
                }

                &.nav {
                    ul li {
                        a {
                            @mixin caption;

                            font-weight: 500;
                            text-decoration: none;
                            color: var(--av-brand-secondary);
                        }
                    }
                }

                &.social {
                    justify-content: flex-start;
                    margin-top: 16px;

                    @media (--viewport-tablet) {
                        margin-top: 25px;
                        grid-column-start: 2;
                        grid-column-end: 3;
                    }
                }
            }
        }
    }
}
</style>

<style lang="postcss">
.newsletter-sample {
    .footer {
        .a-social__link {
            margin-inline-start: 0;
            margin-inline-end: 8px;
            svg {
                fill: rgba(191, 205, 224, 1);
                max-height: 20px;
                max-width: 20px;
            }
        }
    }
    .a-link_type_regular .a-link__content {
        color: var(--av-inversed-primary);
    }
}
</style>
